var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54398 0.929532C4.36766 1.03411 3.25962 1.55673 2.40766 2.40879C0.409362 4.40734 0.409362 7.59341 2.40766 9.59196C4.40595 11.5905 7.5916 11.5905 9.58989 9.59196C10.4546 8.72717 10.9648 7.63353 11.0707 6.41815C11.1032 6.0455 11.0981 5.94276 11.0416 5.8302C10.9804 5.70829 10.8831 5.6394 10.7545 5.62704C10.5826 5.61053 10.4192 5.69832 10.3605 5.83878C10.3432 5.88034 10.3247 6.03107 10.314 6.21768C10.278 6.8487 10.153 7.33121 9.87794 7.90025C9.34334 9.0064 8.26315 9.88902 7.0789 10.1873C6.65595 10.2939 6.53827 10.3069 5.99877 10.3069C5.45928 10.3069 5.3416 10.2939 4.91865 10.1873C3.43451 9.81348 2.18616 8.56497 1.81236 7.08064C1.70585 6.65763 1.69282 6.53994 1.69282 6.00038C1.69282 5.46081 1.70585 5.34312 1.81236 4.92011C2.11064 3.7357 2.99314 2.65538 4.09914 2.12071C4.66812 1.84565 5.15056 1.72058 5.7815 1.68459C5.96808 1.67393 6.1188 1.65542 6.16035 1.63806C6.30079 1.57937 6.38857 1.41596 6.37206 1.244C6.3597 1.11544 6.29082 1.0181 6.16893 0.956906C6.06032 0.902377 5.91903 0.89619 5.54398 0.929532Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.61751,
    y1: 4.02209,
    x2: 7.58023,
    y2: 7.98482,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.68811,
    y1: 7.9854,
    x2: 7.65084,
    y2: 4.02267,
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failedIcon.361ccbc87e5776e7aa62071a1c810698.svg";
export { ForwardRef as ReactComponent };